import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="container footer-container">
        <p>&copy; {new Date().getFullYear()} channls. All rights reserved.</p>
        <div className="footer-links">
          <a href="https://t.me/channlverificationbot" target="_blank" rel="noopener noreferrer">Telegram Bot</a>
        </div>
      </div>
    </footer>
  );
}

export default Footer; 